import React from 'react';
import {ConnectState} from '../zviz3/Connect';
import state from '../zviz3/state';

class Explanation extends React.Component{

    constructor(props){
        super(props);

        this.toggleExplanation = this.toggleExplanation.bind(this);
    }

    isOpen(){
        return (this.props.explanationOpen === this.props.id);
    }

    toggleExplanation(event){
        state.set('explanationOpen', 
            (state.get('explanationOpen') === this.props.id? null: this.props.id)
        );
    }

    render(){
        return <div className="seehi_explanation">
            <span className="seehi_explainToggle" tabIndex="0"
                    onKeyDown={(e) => ( e.keyCode !== 13 || this.toggleExplanation(e) )}
                    onClick={this.toggleExplanation}>
                ?
            </span>
            <div className="seehi_explainText"
                    style={{display: this.isOpen()? 'block': 'none'}}>
                {this.props.text}
            </div>
        </div>;
    }

}

Explanation.defaultProps = {
    text: 'Do you go into space waving around a lasso, answer yes. If not answer no.',
    explanationOpen: null,
    id: 'question'
}

export default ConnectState(Explanation, 'explanationOpen');


// WEBPACK FOOTER //
// ./src/elements/explanation.js